<template>
  <div class="container">
    <div class="tabs" :style="{marginTop: '-48px', marginLeft: '-30px'}">
      <ul>
        <li @click="Tabs('view')" :class="{'is-active': isActive === 'view'}">
          <a>ຍອດພະນັກງານສາຂາ</a>
        </li>
        <li @click="Tabs('export')" :class="{'is-active': isActive === 'export'}">
          <a>Export ຍອດພະນັກງານສາຂາ</a>
        </li>
      </ul>
    </div>

    <employeeBalanceView v-if="isActive === 'view'"/>
    <listEmployeeSummaryBranch v-if="isActive === 'export'"/>
  </div>
</template>

<script>
import employeeBalanceView from "./employeeBalanceView";
import listEmployeeSummaryBranch from "./listEmployeeSummaryBranch";

export default {
  components: {
    employeeBalanceView,
    listEmployeeSummaryBranch,
  },

  data: () => ({
    isActive: 'view',
  }),

  methods: {
    Tabs(value) {
      this.isActive = value;
      this.$router.push({name: 'list.branch.employee.summary', query: {tab: value}}).catch(() => {});
    }
  },

  created() {
    if (this.$route.query.tab === 'export') {
      this.isActive = 'export';
    } else {
      this.isActive = 'view';
    }
  }
}
</script>
